<div class="flex-column full-height">
  <vdw-tabs-menu-card icon="datasheets-blue" [title]="'TECHNICAL_DATASHEETS.DATASHEET' | bmsTranslate: {count: 2}"></vdw-tabs-menu-card>
  <mat-card class="flex-column full-height no-margin">
    <mat-sidenav-container [hasBackdrop]="false" class="sidebar-container">
      <mat-sidenav #sidenav class="sidebar-small" mode="over" position="end" [fixedInViewport]="false" [fixedTopGap]="0" [autoFocus]="false" disableClose>
        <app-technical-datasheet-details
          [technicalDatasheetId]="selectedTechnicalDatasheet?.id"
          (closeDetails)="closeTechnicalSheetDetails()"
          (technicalDatasheetDeleted)="onTechnicalDatasheetDeleted($event)"
        ></app-technical-datasheet-details>
      </mat-sidenav>
      <mat-sidenav-content>
        <div fxFlex fxLayout="column" fxLayoutAlign="stretch" class="technical-datasheet-content">
          <div fxLayout="row" fxLayoutAlign="end start" class="toolbar actions">
            <vdw-filter fxFlex="184px" #nameFilter icon="search" (filteredTextChanged)="nameFilterTextChanged($event)"></vdw-filter>
          </div>

          <div fxLayout="row" fxFlex>
            <app-technical-datasheet-thumbnails
              #technicalDatasheetThumbnailsComponent
              fxFlex="100"
              fxLayout="column"
              [advancedSearchFilters]="advancedSearchFilters"
              [selectedTechnicalDatasheet]="selectedTechnicalDatasheet"
              (selectedTechnicalDatasheetChange)="onSelectedTechnicalDatasheetChanged($event)"
            ></app-technical-datasheet-thumbnails>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </mat-card>
</div>
